import React, { useRef, forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { ContextLayout } from '../context-provider';
import { cls } from '@arco-design/mobile-utils';
import { useRefState } from '../_helpers';
import IconArrowDown from '../icon/IconArrowDown';
import { CollapseGroupContext } from './utils';
export var Collapse = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$header = props.header,
      header = _props$header === void 0 ? '' : _props$header,
      icon = props.icon,
      _props$hideIcon = props.hideIcon,
      hideIcon = _props$hideIcon === void 0 ? false : _props$hideIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$content = props.content,
      content = _props$content === void 0 ? null : _props$content,
      _props$defaultActive = props.defaultActive,
      defaultActive = _props$defaultActive === void 0 ? false : _props$defaultActive,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      active = props.active,
      animationTimeout = props.animationTimeout,
      animationFunction = props.animationFunction,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;

  var _useState = useState(false),
      innerActive = _useState[0],
      setInnerActive = _useState[1];

  var _useRefState = useRefState(active === void 0 ? innerActive : active),
      itemActive = _useRefState[0],
      itemActiveRef = _useRefState[1],
      setItemActive = _useRefState[2];

  var _useRefState2 = useRefState(0),
      contentHeight = _useRefState2[0],
      contentHeightRef = _useRefState2[1],
      setContentHeight = _useRefState2[2];

  var collapseHeader = useRef(null);
  var domRef = useRef(null);

  var getStatus = function getStatus(groupContext, val) {
    var show = false; // 优先级： group > children

    if (groupContext.isGroup) {
      if (active !== void 0) {
        show = active;
      }

      if (groupContext.value) show = groupContext.value.includes(val);
    } else {
      show = itemActive;
    }

    return show;
  };

  var onCollapse = function onCollapse(groupContext, val) {
    if (disabled) return;
    props.onCollapse && props.onCollapse(val);

    if (!groupContext.isGroup) {
      setInnerActive(!itemActiveRef.current);
    } else {
      groupContext.onCollapse(value);
    }
  };

  useEffect(function () {
    setItemActive(active === void 0 ? innerActive : active);
  }, [active, innerActive]);
  useImperativeHandle(ref, function () {
    return {
      dom: domRef.current,
      head: collapseHeader.current
    };
  });
  useEffect(function () {
    // defaultActive为true时，contentHeight更新晚于构建，使用这种方法强制刷新
    setInnerActive(defaultActive);
  }, []);
  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement(CollapseGroupContext.Consumer, null, function (groupContext) {
      return /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-collapse-item", className, {
          disabled: disabled || groupContext.disabled
        }),
        style: style,
        ref: domRef
      }, /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-collapse-header"),
        ref: collapseHeader,
        onClick: function onClick() {
          return onCollapse(groupContext, value);
        }
      }, header, !hideIcon && /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-collapse-icon")
      }, icon || /*#__PURE__*/React.createElement(IconArrowDown, {
        className: prefixCls + "-collapse-icon-arrow",
        style: {
          transform: "rotate(" + (getStatus(groupContext, value) ? '180deg' : '0deg') + ")"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-collapse-content"),
        style: {
          height: getStatus(groupContext, value) ? contentHeight + "px" : 0,
          transitionDuration: animationTimeout !== void 0 ? animationTimeout + "ms" : void 0,
          transitionTimingFunction: animationFunction
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-collapse-content-container"),
        ref: function ref(div) {
          var _div$getBoundingClien, _div$getBoundingClien2;

          var height = (_div$getBoundingClien = div == null ? void 0 : (_div$getBoundingClien2 = div.getBoundingClientRect()) == null ? void 0 : _div$getBoundingClien2.height) != null ? _div$getBoundingClien : 0;

          if (height && height !== contentHeightRef.current) {
            setContentHeight(height);
          }
        }
      }, content)));
    });
  });
});